/**
 * 表单字段
 * forms1 [{
 * 
 * 
 * 
 * }]
 */
export const forms = [
    { id: 2, name: '学校少先队组织信息' },
    { id: 3, name: '少先队总辅导员信息' },
    { id: 4, name: '大队辅导员本年度参加培训情况' },
    { id: 5, name: '总辅导员本年度参加培训情况' },
    { id: 6, name: '“红领巾奖章”评定颁发情况' }
]

// 学校少先队组织信息（配备大队辅导员的由大队辅导员填写，未配备的由学校指定人员填写）：
export const forms1 = [{
    fieldName: 'schoolType',
    text: '学校类型',
    type: 'select',
    isRequired: true,
    options: [{
        key: 1,
        value: '公立小学'
    }, {
        key: 2,
        value: '私立小学'
    }, {
        key: 3,
        value: '公立初中'
    }, {
        key: 4,
        value: '私立初中'
    }, {
        key: 5,
        value: '公立 9 年一贯制'
    }, {
        key: 6,
        value: '私立 9 年一贯制'
    }],
    level: 1,
}, {

    fieldName: 'schoolBuildingTeam',
    text: '学校是否建队',
    isRequired: true,
    type: 'radio',
    option: [{
        key: 1,
        value: '是',
    }, {
        key: 0,
        value: '否'
    }],
}, {
    fieldName: 'isBrigadeCounselor',
    text: '是否为大队辅导员',
    isRequired: true,
    type: 'radio',
    option: [{
        key: '是',
        value: 1
    }, {
        key: '否',
        value: 0
    }],
    childFields: [{
        fieldName: 'name',
        text: '姓名',
        isRequired: true,
        type: 'text',
    }, {
        fieldName: 'sex',
        text: '性别',
        isRequired: true,
        type: 'radio',
        option: [{
            key: 1,
            value: '男'
        }, {
            key: 2,
            value: '女'
        }]
    }, {
        fieldName: 'birthday',
        text: '出生日期',
        isRequired: true,
        type: 'month', // 年月
    }, {
        fieldName: 'edu',
        text: '学历',
        type: 'radio',
        isRequired: true,
        options: [{
            key: 1,
            value: '全日制研究生'
        }, {
            key: 2,
            value: '在职研究生'
        }, {
            key: 3,
            value: '党校研究生'
        }, {
            key: 4,
            value: '全日制本科'
        }, {
            key: 5,
            value: '非全日制本科'
        }, {
            key: 6,
            value: '全日制大专'
        }, {
            key: 7,
            value: '非全日制大专'
        }, {
            key: 8,
            value: '其他'
        }],
        level: 1,
    }, {
        fieldName: 'zzmm',
        text: '政治面貌',
        isRequired: true,
        type: 'radio',
        option: [{
            key: 1,
            value: '中共党员'
        }, {
            key: 2,
            value: '共青团员'
        }, {
            key: 3,
            value: '群众'
        }, {
            key: 4,
            value: '其他'
        }]
    }, {
        fieldName: 'tel',
        text: '手机号',
        isRequired: true,
        type: 'text',
        // check: `/^1[34578]\d{9}$/`,
    }, {
        fieldName: 'job',
        text: '校内职级',
        isRequired: true,
        type: 'select',
        option: [{
            key: '校长兼任',
            value: '校长兼任'
        }, {
            key: '副校长兼任',
            value: '副校长兼任'
        }, {
            key: '兼任德育主任',
            value: '兼任德育主任'
        }, {
            key: '兼任德育副主任',
            value: '兼任德育副主任'
        }, {
            key: '相当于德育主任职级',
            value: '相当于德育主任职级'
        }, {
            key: '相当于德育副主任职级',
            value: '相当于德育副主任职级'
        }, {
            key: '无职级',
            value: '无职级'
        }]
    }, {
        fieldName: 'counselorTime',
        text: '担任大队辅导员时间',
        isRequired: true,
        type: 'month', // 年月
    }, {
        fieldName: 'title',
        text: '职称',
        isRequired: true,
        type: 'select',
        option: [{
            key: 1,
            value: '三级及以下'
        }, {
            key: 2,
            value: '二级'
        }, {
            key: 3,
            value: '一级'
        }, {
            key: 4,
            value: '高级'
        }, {
            key: 5,
            value: '正高级'
        }]

    }, {
        fieldName: 'concurrentCourses',
        text: '兼教课程',
        isRequired: true,
        type: 'select',
        option: [{
            key: 1,
            value: '无'
        }, {
            key: 2,
            value: '只兼语文/数学/外语等主课'
        }, {
            key: 3,
            value: '只兼思政课'
        }, {
            key: 4,
            value: '只兼其他课程'
        }, {
            key: 5,
            value: '同时兼思政课和主课'
        }, {
            key: 6,
            value: '同时兼思政课和其他课'
        }, {
            key: 7,
            value: '同时兼主课和其他课'
        }]
    }, {
        fieldName: 'classHour',
        text: '每周课时',
        isRequired: true,
        type: 'text',
    }, {
        fieldName: 'squadronNum',
        text: '中队数量',
        isRequired: true,
        type: 'text',
    }, {
        fieldName: 'squadronCounselorsNum',
        text: '中队辅导员人数',
        isRequired: true,
        type: 'text',
    }, {
        fieldName: 'YoungNum',
        text: '少先队员人数',
        isRequired: true,
        type: 'text',
    }, {
        fieldName: 'brigadeOutsideCounselorsNum',
        text: '大队聘请的校外辅导员总人数',
        isRequired: true,
        type: 'text',
    }, {
        fieldName: 'squadronOutsideCounselorsNum',
        text: '中队聘请的校外辅导员总人数',
        isRequired: true,
        type: 'text',
    }, {
        fieldName: 'batchTeam',
        text: '目前学校学生分几批次入队',
        isRequired: true,
        type: 'select',
        option: [{
            key: 1,
            value: '未分批'
        }, {
            key: 2,
            value: '分两批'
        }, {
            key: 3,
            value: '分三批'
        }, {
            key: 4,
            value: '其他'
        }]
    }, {
        fieldName: 'redScarf',
        text: ' 目前学生入队时首次佩戴的红领巾是否由学校统一配发',
        isRequired: true,
        type: 'radio',
        option: [{
            key: 1,
            value: '是'
        }, {
            key: 2,
            value: '否'
        }]
    }, {
        fieldName: 'badge',
        text: '目前学生入队时首次佩戴的队徽徽章是否由学校统一配发',
        isRequired: true,
        type: 'radio',
        option: [{
            key: 1,
            value: '是'
        }, {
            key: 2,
            value: '否'
        }]
    }, {
        fieldName: 'redScarfMedal',
        text: '目前学校是否开展“红领巾奖章”基础章争章活动',
        isRequired: true,
        type: 'radio',
        level: 2,
        option: [{
            key: 1,
            value: '是'
        }, {
            key: 2,
            value: '否'
        }],
        childFields: [{
            fieldName: 'oneStar',
            text: '是否颁发了一星章',
            isRequired: true,
            type: 'radio',
            option: [{
                key: 1,
                value: '是'
            }, {
                key: 2,
                value: '否'
            }]
        }]
    }, {
        fieldName: 'schoolsgw',
        text: '学校是否成立学校少工委',
        isRequired: true,
        type: 'radio',
        level: 2,
        option: [{
            key: 1,
            value: '是'
        }, {
            key: 2,
            value: '否'
        }],
        childFields: [{
            fieldName: 'sgwName',
            text: '学校少工委主任姓名',
            isRequired: true,
            type: 'text',
        }, {
            fieldName: 'sgwJob',
            text: '学校少工委主任职务',
            isRequired: true,
            type: 'select',
            option: [{
                key: 1,
                value: '党员校长'
            }, {
                key: 2,
                value: '学校党组织书记'
            }, {
                key: 3,
                value: '非党员校长'
            }, {
                key: 4,
                value: '其他'
            }],
        }, {
            fieldName: 'sdhsj',
            text: '本届少代会召开时间',
            isRequired: true,
            type: 'month', // 年月
        }]
    }],
    level: 2,
}]

export const forms2 = [{
    fieldName: 'levelSGWDirector',
    text: '本级少工委主任（2 人）',
    type: 'radio',
    isRequired: true,
    options: [{
        key: 1,
        value: '1人'
    }, {
        key: 2,
        value: '2人'
    }],
}, {
    fieldName: 'levelSGWDirectorName',
    text: '本级少工委主任姓名',
    type: 'text',
    isRequired: true,
}, {
    fieldName: 'levelSGWDirectorJob',
    text: '本级少工委主任职务',
    type: 'radio',
    isRequired: true,
    options: [{
        key: 1,
        value: '团委主要负责同志'
    }, {
        key: 2,
        value: '团委负责同志'
    }, {
        key: 3,
        value: '团委其他同志'
    }, {
        key: 4,
        value: '教育部门负责同志'
    }, {
        key: 5,
        value: '教育部门其他同志'
    }],
    childFields: [{
        fieldName: 'levelSGWDirectorJobOther',
        text: '本级少工委主任职务其他职务',
        type: 'text',
    }]
}, {
    fieldName: 'levelSGWDirectorName2',
    text: '本级少工委主任姓名',
    type: 'text',

}, {
    fieldName: 'levelSGWDirectorJob2',
    text: '本级少工委主任职务',
    type: 'radio',
    options: [{
        key: 1,
        value: '团委主要负责同志'
    }, {
        key: 2,
        value: '团委负责同志'
    }, {
        key: 3,
        value: '团委其他同志'
    }, {
        key: 4,
        value: '教育部门负责同志'
    }, {
        key: 5,
        value: '教育部门其他同志'
    }],
    childFields: [{
        fieldName: 'levelSGWDirectorJob2Other',
        text: '本级少工委主任职务其他职务',
        type: 'text',
    }]
}, {
    fieldName: 'sdhsj',
    text: '本届少代会召开时间',
    isRequired: true,
    type: 'month', // 年月
}, {
    fieldName: 'levelOutsideCounselorsNum',
    text: '本级校外辅导员资源库人数',
    type: 'number',
}, {
    fieldName: 'levelCounselors',
    text: '是否为本级少先队总辅导员',
    type: 'radio',
    isRequired: true,
    options: [
        {
            key: 1,
            value: '是'
        }, {
            key: 2,
            value: '否'
        }
    ],
    childFields: [{
        fieldName: 'name',
        text: '姓名',
        type: 'text',
        isRequired: true,
    }, {
        fieldName: 'sex',
        text: '性别',
        type: 'radio',
        isRequired: true,
        options: [
            {
                key: 1,
                value: '男'
            }, {
                key: 2,
                value: '女'
            }
        ],
    }, {
        fieldName: 'birthday',
        text: '出生日期',
        isRequired: true,
        type: 'month', // 年月
    }, {
        fieldName: 'edu',
        text: '学历',
        type: 'radio',
        isRequired: true,
        options: [{
            key: 1,
            value: '全日制研究生'
        }, {
            key: 2,
            value: '在职研究生'
        }, {
            key: 3,
            value: '党校研究生'
        }, {
            key: 4,
            value: '全日制本科'
        }, {
            key: 5,
            value: '非全日制本科'
        }, {
            key: 6,
            value: '全日制大专'
        }, {
            key: 7,
            value: '非全日制大专'
        }, {
            key: 8,
            value: '其他'
        }],
    }, {
        fieldName: 'zzmm',
        text: '政治面貌',
        isRequired: true,
        type: 'radio',
        option: [{
            key: 1,
            value: '中共党员'
        }, {
            key: 2,
            value: '共青团员'
        }, {
            key: 3,
            value: '群众'
        }, {
            key: 4,
            value: '其他'
        }]
    }, {
        fieldName: 'tel',
        text: '手机号',
        isRequired: true,
        type: 'text',
        // check: '/^1[34578]\d{9}$/',
    }, {
        fieldName: 'company',
        text: '编制所在单位',
        isRequired: true,
        type: 'radio',
        option: [{
            key: 1,
            value: '同级团委'
        }, {
            key: 2,
            value: '同级教育部门'
        }, {
            key: 3,
            value: '青少年宫'
        }, {
            key: 4,
            value: '其他团属事业单位'
        }, {
            key: 5,
            value: '其他教育部门下属事业单位'
        }, {
            key: 6,
            value: '中小学校'
        }]
    }, {
        fieldName: 'administrationLevel',
        text: '行政级别',
        isRequired: true,
        type: 'radio',
        option: [{
            key: 1,
            value: '中层正职（含）以上'
        }, {
            key: 2,
            value: '中层副职'
        }, {
            key: 3,
            value: '中层副职以下'
        }, {
            key: 4,
            value: '无'
        }]
    }, {
        fieldName: 'postType',
        text: '岗位类型',
        isRequired: true,
        type: 'radio',
        option: [{
            key: 1,
            value: '专职'
        }, {
            key: 2,
            value: '兼职'
        }]
    }]
}]
// 大队辅导员本年度参加培训情况（每年 11 月 1 日至11 月 15 日统计，非大队辅导员的用户不填）
export const forms3 = [{
    fieldName: 'train',
    text: '本年度是否参加过培训',
    type: 'radio',
    isRequired: true,
    options: [
        {
            key: 1,
            value: '是'
        }, {
            key: 2,
            value: '否'
        }
    ],
    childFields: [{
        fieldName: 'trainName',
        text: '培训名称',
        type: 'text',
        isRequired: true,
    }, {
        fieldName: 'trainLevel',
        text: '培训级别',
        type: 'radio',
        isRequired: true,
        options: [
            {
                key: 1,
                value: '全国级'
            }, {
                key: 2,
                value: '省级'
            }, {
                key: 3,
                value: '市级'
            }, {
                key: 4,
                value: '县级'
            }
        ],
    }, {
        fieldName: 'organizer',
        text: '主办单位',
        type: 'radio',
        isRequired: true,
        options: [
            {
                key: 1,
                value: '团委或少工委'
            }, {
                key: 2,
                value: '教育部门'
            }, {
                key: 3,
                value: '团属事业单位'
            }, {
                key: 4,
                value: '教育部门下属事业单位'
            }, {
                key: 5,
                value: '其他机构'
            }
        ],
    }, {
        fieldName: 'classHours',
        text: '学时',
        type: 'number',
        isRequired: true,
    }, {
        fieldName: 'trainDate',
        text: '培训日期',
        isRequired: true,
        type: 'month', // 年月
    }]
}]
// （二）总辅导员本年度参加培训情况（每年 11 月 1 日至 11月 15 日统计，由省、市、县级总辅导员填写，非总辅导员的用户不填）
export const forms4 = [{
    fieldName: 'train',
    text: '本年度是否参加过培训',
    type: 'radio',
    isRequired: true,
    options: [
        {
            key: 1,
            value: '是'
        }, {
            key: 2,
            value: '否'
        }
    ],
    childFields: [{
        fieldName: 'trainName',
        text: '培训名称',
        type: 'text',
        isRequired: true,
    }, {
        fieldName: 'trainLevel',
        text: '培训级别',
        type: 'radio',
        isRequired: true,
        options: [
            {
                key: 1,
                value: '全国级'
            }, {
                key: 2,
                value: '省级'
            }, {
                key: 3,
                value: '市级'
            }, {
                key: 4,
                value: '县级'
            }
        ],
    }, {
        fieldName: 'organizer',
        text: '主办单位',
        type: 'radio',
        isRequired: true,
        options: [
            {
                key: 1,
                value: '团委或少工委'
            }, {
                key: 2,
                value: '教育部门'
            }, {
                key: 3,
                value: '团属事业单位'
            }, {
                key: 4,
                value: '教育部门下属事业单位'
            }, {
                key: 5,
                value: '其他机构'
            }
        ],
    }, {
        fieldName: 'classHours',
        text: '学时',
        type: 'number',
        isRequired: true,
    }, {
        fieldName: 'trainDate',
        text: '培训日期',
        isRequired: true,
        type: 'month', // 年月
    }]
}]

export const forms5 = [{
    fieldName: 'redScarfMedal',
    text: '今年内是否开展“红领巾奖章”评定颁发？',
    type: 'radio',
    isRequired: true,
    options: [
        {
            key: 1,
            value: '是'
        }, {
            key: 2,
            value: '否'
        }
    ],
    childFields: [{
        // 县级总辅导员填写
        fieldName: 'twoStar',
        text: '二星章',
        type: 'radio',
        isRequired: true,
        options: [
            {
                key: 1,
                value: '是'
            }, {
                key: 2,
                value: '否'
            }
        ],
    }, {
        // 是、否，直辖市县级总辅导员填写
        fieldName: 'twoOrThreeStar',
        text: '二星章或三星章',
        type: 'radio',
        isRequired: true,
        options: [
            {
                key: 1,
                value: '是'
            }, {
                key: 2,
                value: '否'
            }
        ],
    }, {
        // 市级总辅导员填写
        fieldName: 'threeStar',
        text: '三星章',
        type: 'radio',
        isRequired: true,
        options: [
            {
                key: 1,
                value: '是'
            }, {
                key: 2,
                value: '否'
            }
        ],
    }, {
        // 省级总辅导员填写
        fieldName: 'fourStar',
        text: '四星章',
        type: 'radio',
        isRequired: true,
        options: [
            {
                key: 1,
                value: '是'
            }, {
                key: 2,
                value: '否'
            }
        ],
    }]
}]
